import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('mncwest_token');
    if (token) {
      api.get('/auth/me').then(r => setAdmin(r.data)).catch(() => localStorage.removeItem('mncwest_token')).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const orgId = process.env.REACT_APP_ORG_ID || 'mncwest';
    const { data } = await api.post('/auth/login', { email, password, orgId });
    localStorage.setItem('mncwest_token', data.token);
    setAdmin(data.admin);
    return data.admin;
  };

  const logout = () => {
    localStorage.removeItem('mncwest_token');
    setAdmin(null);
  };

  return <AuthContext.Provider value={{ admin, login, logout, loading }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
